import { Flex, Modal, NumberInput, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useEffect } from 'react'
import { IconDatabasePlus, IconArrowBarLeft } from '@tabler/icons-react'
import api from 'src/utils/Api'
import { EDIT_OPERACIONAL, FIND_FIRST_OPERACIONAL } from 'src/utils/Routes'
import { useForm, zodResolver } from '@mantine/form'
import { validaOperacional } from './validation/schema'
import { ErrorNotification } from '../notification/errorNotification'
import {
  MESSAGE_ERROR_SERVIDOR,
  PLEASE_FILL_IN_ALL_REQUIRED_FIELDS,
  TITTLE_NOTICE,
} from 'src/utils/Constants'
import { WarningNotification } from '../notification/warningNotification'
import IOperacional from 'src/interfaces/IOperacional'
import { SuccessNotification } from '../notification/successNotification'
import CustomButtom from '../customButtom'

type props = {
  openModal: boolean
  onClose: (val: boolean) => void
}

const ModalOperacional: React.FC<props> = ({ openModal, onClose }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const form = useForm<{
    id: number | null
    comissao: number
    custoFinanceiro: number
    margemSeguranca: number
    despesaOperacional: number
  }>({
    initialValues: {
      id: null,
      comissao: 0,
      custoFinanceiro: 0,
      margemSeguranca: 0,
      despesaOperacional: 0,
    },
    validate: zodResolver(validaOperacional()),
  })
  useEffect(() => {
    if (openModal) {
      open()
      findOperacional()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal])
  const closeModal = () => {
    onClose(false)
    close()
  }
  const findOperacional = () => {
    api
      .get(FIND_FIRST_OPERACIONAL)
      .then(r => form.setValues(r.data))
      .catch(() => {
        ErrorNotification({ message: MESSAGE_ERROR_SERVIDOR })
      })
  }
  const handleChange = (
    event: string | number | boolean,
    key: keyof IOperacional
  ) => {
    form.setFieldValue(key, event)
  }
  const handleSubmit = () => {
    api
      .put(EDIT_OPERACIONAL, form.values)
      .then(resp => {
        SuccessNotification({ message: resp.data })
        closeModal()
      })
      .catch(() => {
        ErrorNotification({ message: MESSAGE_ERROR_SERVIDOR })
      })
  }
  return (
    <Modal
      centered
      opened={opened}
      onClose={close}
      size={'md'}
      title={<Text fw={'bold'}>Operacional</Text>}
    >
      <form
        onSubmit={form.onSubmit(
          () => handleSubmit(),
          () => {
            WarningNotification({
              title: TITTLE_NOTICE,
              message: PLEASE_FILL_IN_ALL_REQUIRED_FIELDS,
            })
          }
        )}
      >
        <Flex direction={'row'} align={'center'} gap={'sm'}>
          <NumberInput
            mt={'md'}
            withAsterisk
            {...form.getInputProps('despesaOperacional')}
            step={0.05}
            precision={2}
            onChange={v => handleChange(v, 'despesaOperacional')}
            min={0}
            label="Despesa operacional"
            placeholder="Digite o porcentagem da despesa operacional"
            formatter={value => `${value.replace('.', ',')}%`}
            parser={value => value?.replace('%', '').replace(',', '.')}
          />
          <NumberInput
            mt={'md'}
            withAsterisk
            {...form.getInputProps('comissao')}
            step={0.05}
            precision={2}
            onChange={v => handleChange(v, 'comissao')}
            min={0}
            label="Comissão"
            placeholder="Digite o porcentagem da comissão"
            formatter={value => `${value.replace('.', ',')}%`}
            parser={value => value?.replace('%', '').replace(',', '.')}
          />
        </Flex>
        <Flex direction={'row'} align={'center'} gap={'sm'}>
          <NumberInput
            mt={'md'}
            withAsterisk
            {...form.getInputProps('custoFinanceiro')}
            step={0.05}
            precision={2}
            onChange={v => handleChange(v, 'custoFinanceiro')}
            min={0}
            label="Custo financeiro"
            placeholder="Digite o porcentagem do custo financeiro"
            formatter={value => `${value.replace('.', ',')}%`}
            parser={value => value?.replace('%', '').replace(',', '.')}
          />
          <NumberInput
            mt={'md'}
            withAsterisk
            {...form.getInputProps('margemSeguranca')}
            step={0.05}
            precision={2}
            onChange={v => handleChange(v, 'margemSeguranca')}
            min={0}
            label="Margem de segurança"
            placeholder="Digite o porcentagem da margem de segurança"
            formatter={value => `${value.replace('.', ',')}%`}
            parser={value => value?.replace('%', '').replace(',', '.')}
          />
        </Flex>
        <CustomButtom
          customJustify="space-between"
          customButtons={[
            {
              label: 'Voltar',
              color: 'red',
              onClick: () => closeModal(),
              icon: <IconArrowBarLeft />,
              type: 'button',
            },
            {
              label: 'Salvar',
              icon: <IconDatabasePlus />,
              type: 'submit',
            },
          ]}
        />
      </form>
    </Modal>
  )
}
export default ModalOperacional
